// extracted by mini-css-extract-plugin
export default {"checkedStatus":"UseHotWalletTableColumns_checkedStatus__-mN9B","link":"UseHotWalletTableColumns_link__Xp7+t","number":"UseHotWalletTableColumns_number__Fhye4"};